module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-4.jpg?v=b9f4118c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-4.jpg
 ** module id = 40
 ** module chunks = 1 2
 **/